import { useQuery } from '@tanstack/react-query';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { EmptyState, Page } from '@/components/Page';
import { api } from '@/lib/api';

interface Webhook {
  id: string;
  url: string;
  events: string[];
  active: boolean;
  created_at: string;
}

export function WebhooksPage() {
  const webhooks = useQuery({
    queryKey: ['webhooks'],
    queryFn: () => api<Webhook[]>('/v1/webhooks'),
  });

  return (
    <Page title="Webhooks" subtitle="Receive events when files change.">
      {webhooks.isLoading ? (
        <Skeleton className="h-40 w-full" />
      ) : !webhooks.data || webhooks.data.length === 0 ? (
        <EmptyState title="No webhooks yet" hint="POST /v1/webhooks to register one." />
      ) : (
        <Card>
          <CardContent className="divide-y p-0">
            {webhooks.data.map((w) => (
              <div key={w.id} className="px-4 py-3">
                <div className="font-mono text-sm">{w.url}</div>
                <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
                  {w.events.map((e) => (
                    <Badge key={e} variant="outline">
                      {e}
                    </Badge>
                  ))}
                  <Badge variant={w.active ? 'secondary' : 'outline'}>
                    {w.active ? 'active' : 'inactive'}
                  </Badge>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>
      )}
    </Page>
  );
}
